<template>
    <div>
        <breadCrumb 
            :icon="'fa-cash-register'"
            :category="$t(`sideNav.navSalonReport`)"
            :subCategory="$t(`subMenu.salon_report_payment`)"
            :subSubCategory="''">
        </breadCrumb>
        <div class="row mt-3">
            <div class="col-sm-12 col-md-4">
                <div class="p-3 rounded overflow-hidden position-relative text-white bg-success-500">
                    <h3 class="fs-xxl d-block l-h-n m-0 fw-500">
                        {{parseFloat(totalPayment).toFixed(2)}}
                        <small class="m-0 l-h-n fw-400 text-capitalize">{{$t(`subMenu.salon_report_payment`)}}</small>
                    </h3>
                    <i class="fal fa-cash-register position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n1" style="font-size:5rem"></i>
                </div>
            </div>
            <div class="col-sm-12 col-md-4">
                <div class="p-3 rounded overflow-hidden position-relative text-white bg-warning-500">
                    <h3 class="fs-xxl d-block l-h-n m-0 fw-500">
                        {{parseFloat(rounding).toFixed(2)}}
                        <small class="m-0 l-h-n fw-400 text-capitalize">{{$t('table.header.rounding')}}</small>
                    </h3>
                    <i class="fal fa-redo position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-2" style="font-size:5rem"></i>
                </div>
            </div>
            <div class="col-sm-12 col-md-4">
                <div class="p-3 rounded overflow-hidden position-relative text-white bg-primary-500">
                    <h3 class="fs-xxl d-block l-h-n m-0 fw-500">
                        {{parseFloat(tax).toFixed(2)}}
                        <small class="m-0 l-h-n fw-400 text-capitalize">{{$t('table.header.tax')}}</small>
                    </h3>
                    <i class="fal fa-file-invoice-dollar position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n1" style="font-size:5rem"></i>
                </div>
            </div>
        </div>
        <div class="pt-3">
            <h6 class="border-bottom text-dark fw-500">{{$t('table.header.payment_method')}}</h6>
            <div class="row" data-spy="scroll" data-target="#itemSP" data-offset="0">
                <div class="col-sm-12 overflow-auto">
                    <table class="table table-sm table-hover table-bordered table-striped w-100 dataTable dtr-inline" role="grid" style="height: 1px">
                        <thead class="thead-themed">
                            <tr>
                                <th class="text-capitalize align-middle" v-for="tblHeader in paymentTypeTotal" :key="'tblHdr' + tblHeader.paymentTypeID">{{tblHeader.paymentMethod}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td v-for="item in paymentTypeTotal" :key="item.paymentTypeID">{{parseFloat(item.total).toFixed(2)}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <ul class="nav nav-tabs nav-tabs-clean px-3 px-sm-5" role="tablist">
            <li class="nav-item" v-for="t in $i18n.messages[$i18n.locale].tab.reportPaymentTabs" :key="t.id">
                <a class="nav-link bg-transparent fs-lg fw-400" :class="{'active': selectedTab == t.id}" @click="selectedTab = t.id">{{t.text}}</a>
            </li>
        </ul>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4">
                    <paymentFilter ref="paymentFilter" :paymentType="paymentType" @filterPayment="filterPayment"></paymentFilter>
                </div>
                <div class="panel-container show">
                    <div class="panel-content">
                        <div class="tab-content">
                            <paymentDate ref="paymentDate" class="tab-pane" :class="{'active': selectedTab == 'date'}" :paymentType="paymentType" @setExportData="setExportData" @setPaymentTotal="setPaymentTotal"></paymentDate>
                            <paymentOrder ref="paymentOrder" class="tab-pane" :class="{'active': selectedTab == 'order'}" @setPaymentTotal="setPaymentTotal" @setExportData="setExportData"></paymentOrder>
                        </div>
                    </div>
                </div> 
            </div>
        </div>
        <div :class="{'show': isSpinnerShow}" class="modal fade">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content border-0 ">
                    <div class="modal-body text-center">
                        <div class="spinner-border text-light" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                        <div class="text-light mt-2">{{$t('message.data.fetching_wait')}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BreadCrumb from './../../Bread_Crumb'
import PaymentFilter from './Payment_Filter'
import PaymentDate from './Payment_Date'
import PaymentOrder from './Payment_Order'
import moment from 'moment'
import {handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
import {getPaymentTypeTitle} from './../../../../assets/js/dashboard/salonReport/salonReport'

export default {
    name: "reportPayment",
    components:{
        PaymentFilter, PaymentDate, PaymentOrder, BreadCrumb
    },
    data(){
        return{
            selectedTab: 'date',
            paymentType: [], filterObj: {}, paymentItem: [],
            member: [], paymentConfig: [],
            isSpinnerShow: false, totalPayment: 0, paymentTypeTotal: [], exportObj: {},
            rounding: 0, tax: 0,
            memberCache: {},
        }
    },
    watch:{
        selectedTab(value){
            value == 'date' ? this.$refs.paymentDate.setPaymentItem(this.paymentItem, this.filterObj) : this.$refs.paymentOrder.setPaymentItem(this.paymentType, this.paymentItem, this.filterObj)
            this.$refs.paymentFilter.tab = value
        },
        "$i18n.locale"(val){
            this.getPaymentType()
            if(this.selectedTab == 'order'){
                this.$refs.paymentOrder.setPaymentItem(this.paymentType, this.paymentItem, this.filterObj)
            }
        }
    },
    methods:{
        setExportData(item){
            this.exportObj = item
            this.$refs.paymentFilter.setExportData(item)
        },
        setPaymentTotal(items){
            this.totalPayment = 0
            for(var i=0; i<items.length; i++){
                this.totalPayment += items[i].total
            }
            this.paymentTypeTotal = items
        },
        async filterPayment(filterObj){
            this.isSpinnerShow = true
            this.filterObj = filterObj
            var result = await this.getPaymentItem(filterObj)
            this.tax = await this.getCommissionItems(filterObj)
            this.rounding = await this.getSalesItems(filterObj)
            this.paymentItem = result
            this.selectedTab == 'date' ? this.$refs.paymentDate.setPaymentItem(result, filterObj) : this.$refs.paymentOrder.setPaymentItem(this.paymentType, result, filterObj)
            this.isSpinnerShow = false
        },
        async getCommissionItems(filterObj){
            var dateFilter = "?startDate=" + moment(filterObj.date.startDate).format('DD/MM/YYYY') + "&endDate=" + moment(filterObj.date.endDate).format('DD/MM/YYYY')
            var outletFilter = filterObj.outlet.id == "all" ? "" : "&outletID=" + filterObj.outlet.id
            outletFilter = ''
            var searchFilter = filterObj.search == "" ? "" : "&search=" + filterObj.search

            let QUERY_STRING = dateFilter + outletFilter + searchFilter

            let filteredOutletID = filterObj.outlet.map(k => k['id'])

            const url =  this.$api.REPORT_COMPLETED + QUERY_STRING;
            var result = [];
            let $vm = this
            await this.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()}
            })
            .then(function(response) {
                result = response.data.result
                result = result.filter(k => {
                    return filteredOutletID.includes(k['outletID'])
                });
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            var tax = 0
            for(var i=0; i<result.length; i++){
                tax += result[i].tax.tax
            }
            return tax;
        },
        async getSalesItems(filterObj){
            let $vm = this
            var dateFilter = "?startDate=" + moment(filterObj.date.startDate).unix() + "&endDate=" + moment(filterObj.date.endDate).unix()
            var outletFilter = filterObj.outlet.id == "all" ? "" : "&outletID=" + filterObj.outlet.id
            outletFilter = ''
            var searchFilter = filterObj.search == "" ? "" : "&search=" + filterObj.search

            let QUERY_STRING = dateFilter + outletFilter + searchFilter

            let filteredOutletID = filterObj.outlet.map(k => k['id'])

            const url =  this.$api.REPORT_SALES + QUERY_STRING;
            var result = [];
            await this.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()}
            })
            .then(function(response) {
                result = response.data.result;
                result = result.filter(k => {
                    return filteredOutletID.includes(k['outletID'])
                });
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            var rounding = 0
            for(var i=0; i<result.length; i++){
                rounding += result[i].otherAmount.rounding
            }
            return rounding;
        },
        async getPaymentItem(filterObj){
            if(this.member.length == 0){
                this.member = await this.getMemberList()
            }
            
            let DATE_QUERY_STRING = "?startCreateDate=" + moment(filterObj.date.startDate).unix() +  "&endCreateDate=" + moment(filterObj.date.endDate).unix()
            let OUTLET_QUERY_STRING = filterObj.outlet.id == "all" ? "" : "&outletID=" + filterObj.outlet.id
            OUTLET_QUERY_STRING = ''
            const url = this.$api.REPORT_PAYMENT + DATE_QUERY_STRING + OUTLET_QUERY_STRING

            let filteredOutletID = filterObj.outlet.map(k => k['id'])

            let $vm = this;
            var results = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                results = response.data.result;
                results = results.filter(k => {
                    return filteredOutletID.includes(k['outletID'])
                });
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            
            for(var i=0; i<results.length; i++){
                var memberInfo = await this.getMemberInfo(results[i].memberID)
                results[i]['paymentMethod'] = getPaymentTypeTitle(results[i].paymentTypeID, this.paymentType)
                results[i]['memberName'] = memberInfo.name
                results[i]['mobile'] = memberInfo.mobile
            }

            var newResult = []
            if(filterObj.search != ""){
                for(var j=0; j<results.length; j++){
                    if(results[j].memberName != undefined){
                        var memberName = results[j].memberName.toLowerCase()
                        if(memberName.indexOf(filterObj.search.toLowerCase()) != -1 || results[j].mobile.indexOf(filterObj.search) != -1 ){
                            newResult.push(results[j])
                        }
                    }
                }
            }else{
                newResult = results
            }
            return newResult
        },
        async getPaymentConfiguration(){
            let $vm = this;
            var results = []

            await $vm.$axios({
                method: 'get', 
                url: $vm.$api.BRAND_PAYMENT,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                results = response.data.payments;
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return results
        },
        async getPaymentType(){
            var paymentType = [
                 {
                    "paymentTypeID": 1,
                    "title": this.$i18n.t('salon_report.payment.payment_method.' + 'cash')
                },
                {
                    "paymentTypeID": 2,
                    "title": this.$i18n.t('salon_report.payment.payment_method.' + "credit card") 
                },
                {
                    "paymentTypeID": 3,
                    "title": this.$i18n.t('salon_report.payment.payment_method.' + "debit card")
                },
                {
                    "paymentTypeID": 4,
                    "title": this.$i18n.t('salon_report.payment.payment_method.' + "online")
                },
                {
                    "paymentTypeID": 5,
                    "title": "e-wallet 1"
                },
                {
                    "paymentTypeID": 6,
                    "title": "e-wallet 2"
                },
                {
                    "paymentTypeID": 7,
                    "title": this.$i18n.t('salon_report.payment.payment_method.' + "store credits")
                },
                {
                    "paymentTypeID": 8,
                    "title": this.$i18n.t('salon_report.payment.payment_method.' + "store points")
                },
                {
                    "paymentTypeID": 9,
                    "title": this.$i18n.t('salon_report.payment.payment_method.' + "outstandings")
                },
                {
                    "paymentTypeID": 10,
                    "title": this.$i18n.t('salon_report.payment.payment_method.' + "credits redeem")
                },
                {
                    "paymentTypeID": 11,
                    "title": this.$i18n.t('salon_report.payment.payment_method.' + "package redeem")
                },
                {
                    "paymentTypeID": 12,
                    "title": "e-wallet 3"
                },
                {
                    "paymentTypeID": 13,
                    "title": "Option 4"
                },
                {
                    "paymentTypeID": 14,
                    "title": "Option 5"
                },
                {
                    "paymentTypeID": 15,
                    "title": "Option 6"
                },
                {
                    "paymentTypeID": 16,
                    "title": "Option 7"
                },
                {
                    "paymentTypeID": 17,
                    "title": "Option 8"
                },
                {
                    "paymentTypeID": 18,
                    "title": "Option 9"
                },
                {
                    "paymentTypeID": 19,
                    "title": "Option 10"
                }
            ]
            let $vm = this
            if(this.paymentConfig.length == 0){
                this.paymentConfig = await this.getPaymentConfiguration()
            }

            paymentType = paymentType.map(function(p){
                if(p.paymentTypeID == 5){
                    return { ...p, title: $vm.paymentConfig[0] }
                }else if(p.paymentTypeID == 6){
                    return { ...p, title: $vm.paymentConfig[1] }
                }else if(p.paymentTypeID == 12){
                    return { ...p, title: $vm.paymentConfig[2] }
                }else if(p.paymentTypeID > 12){
                    return { ...p, title: $vm.paymentConfig[p.paymentTypeID-10] }
                }else{
                    return p
                }
            });
            this.paymentType = paymentType
        },
        async getMemberInfo(id){
            var memberObj = {}

            // for(var i=0; i<this.member.length; i++){
            //     if(id == this.member[i].memberID){
            //         memberObj["name"] = this.member[i].memberDisplayName
            //         memberObj["mobile"] = this.member[i].mobile
            //         break;
            //     }
            // }

            memberObj = this.memberCache[id]

            if(!memberObj) {
                let shopUsername = this.$store.state.userName
                localStorage.setItem(shopUsername + "@memberDelta", 0)
                localStorage.setItem(shopUsername + "@member", '{}')
                await this.getMemberList()
                memberObj = this.memberCache[id]
            }

            return memberObj || {}
        },
        async getMemberList(){
            let $vm = this;
            var results = []

            // await $vm.$axios({
            //     method: 'get', 
            //     url: $vm.$api.BIZ_MEMBER,
            //     baseURL: $vm.$axios.defaults.baseURL, 
            //     headers: {token: $vm.$session.get('token')}
            // })
            // .then(function(response) {
            //     results = response.data.result;
            // })
            // .catch((err) => {
            //     var error = err.response.data.error;
            //     if(error == $vm.$api.INVALID_TOKEN){
            //         handleSessionExpired();   
            //     }
            // })

            let storageMember = {}
            
            let shopUsername = $vm.$store.state.userName
            let timestamp = Date.now() / 1000
            let memberDelta = localStorage.getItem(shopUsername + "@memberDelta") || 0
            // memberDelta = 0

            try {
                storageMember = JSON.parse(localStorage.getItem(shopUsername + "@member")) || {}
            } catch(e) {
                localStorage.setItem(shopUsername + "@memberDelta", memberDelta = 0)
                localStorage.setItem(shopUsername + "@member", JSON.stringify(storageMember = {}))
            }

            await $vm.$axios({
                method: 'get', 
                url: 'https://devm6.tunai.io/business/member?delta=' + memberDelta,
                headers: {token: $vm.$session.get('token')}
            })
            .then((response) => {
                let members = results = response.data['members'];

                for(let member of members) {
                    // delete member['memberID'];
                    // delete member['name'];
                    // delete member['mobile'];
                    delete member['nick1'];
                    delete member['nick2'];
                    delete member['mobile1'];
                    delete member['mobile2'];
                    delete member['nationalID'];
                    delete member['dob'];
                    delete member['gender'];
                    delete member['marital'];
                    delete member['image'];
                    delete member['vip'];
                    delete member['vvip'];
                    delete member['vvvip'];
                    delete member['day1'];
                    delete member['pin'];
                    delete member['ethnicID'];
                    delete member['createDate'];
                    delete member['deleteDate'];
                    delete member['hideDate'];
                    delete member['credits'];
                    delete member['points'];
                    delete member['outstandings'];
                    delete member['months1'];
                    delete member['months2'];
                    delete member['months3'];
                    storageMember[member['memberID']] = member
                }

                localStorage.setItem(shopUsername + "@memberDelta", timestamp);
                localStorage.setItem(shopUsername + "@member", JSON.stringify(storageMember));

                this.memberCache = storageMember
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })

            return results
        },
    },
    async mounted(){
        let $vm = this
        $vm.getPaymentType()
    },
}
</script>
<style scoped>
.nav-link{
    cursor: pointer;
}
.modal-content{
    background: transparent;
    box-shadow: none;
}
.show{
    display: block;
}
</style>